"use client";

import type { RefObject } from "react";

import { useEffect, useRef } from "react";

const LAUNCHER_CALL_TO_ACTION_SELECTOR = "[data-lead-flow-launcher] button";

/**
 * Returns focus to a launcher's call to action when its flow closes. The
 * surface leaves focus alone on close, and closing unmounts the steps, so
 * focus would otherwise fall to the flow's container or the page.
 */
function useLauncherFocus(
  containerRef: RefObject<HTMLDivElement | null>,
  isOpen: boolean,
) {
  const wasOpenRef = useRef(isOpen);

  useEffect(() => {
    if (wasOpenRef.current && !isOpen) {
      containerRef.current
        ?.querySelector<HTMLElement>(LAUNCHER_CALL_TO_ACTION_SELECTOR)
        ?.focus();
    }
    wasOpenRef.current = isOpen;
  }, [containerRef, isOpen]);
}

export { useLauncherFocus };
